import { Theme04Static } from "components";
import { Theme04 } from "pages";
import routesMap from "routeControl/userRouteMap";

export default function route() {
  return [
    {
      path: routesMap.THEME04.path,
      name: "Theme04",
      key: routesMap.THEME04.path,
      commonRoute: false,
      private: true,
      adminAccess: true,
      belongsToSidebar: false,
      element: <Theme04Static />,
    },
    {
      path: `${routesMap.THEME04.path}/:id`,
      name: "Theme04",
      key: `${routesMap.THEME04.path}/:id`,
      commonRoute: true,
      private: true,
      adminAccess: true,
      belongsToSidebar: false,
      element: <Theme04 />,
    },
  ];
}
